import Vue from 'vue';

import { RestComponent } from '../../../mixins/rest-component';
import { TranslatedComponent } from '../../../mixins/translated-component';
import template from './page-article.vhtml';

export const PageArticle = Vue.component( 'page-article', {
	mixins: [ RestComponent, TranslatedComponent ],
	template: template,
	props: {
		postId: Number,
		siteData: {
			type: Object,
			default: () => { },
		},
	},
	methods: {
		goBack() {
			this.$router.go(-1);
		},
	}
});


// WEBPACK FOOTER //
// ./assets/_js/components/post-types/page-article/page-article.js